import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Inject, Input, Optional, Output, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-header-footer-settings',
  templateUrl: './header-footer-settings.component.html',
  styleUrls: ['./header-footer-settings.component.scss']
})
export class HeaderFooterSettingsComponent implements OnDestroy {

  sanitizedUrl: string = '';


  url = '';

  @Input() mode: 'header' | 'footer' = 'header';
  @Output() select = new EventEmitter<string>();

  // Dynamic colors
  // default header background removed (use transparent)
  headerBg = 'transparent';
  headerColor = '#333333';
  footerBg = '#f5f5f5';
  footerColor = '#000000';
  // Horizontal line settings (thickness in px)
  lineEnabled = true;
  lineThickness = 1;
  lineColor = '#e0e0e0';
  // Position: 'top' | 'bottom' (header/footer rule placement)
  linePosition: 'top' | 'bottom' = 'bottom';

  // Dynamic header builder state
  logoSrc: string | null = null;
  logoWidth = '30%';
  headerTitle = 'California Software Company Limited';
  headerSubtitle = 'CIN: L72300TN1992PLC022135\n' +
'Registered Office: Workflo, Greeta Towers, Industrial Estate,\n' +
'Perungudi, OMR Phase 1, Chennai-600096.\n' +
'Email: yeshwant@dspeedup.com Call: +91-94448 60882';


  constructor(
    @Optional() public dialogRef: MatDialogRef<HeaderFooterSettingsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private router: Router
  ) {
    if (data && data.mode) this.mode = data.mode;
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }

  headerTemplates: Array<{ id: string; label: string; html: string }> = [
    { id: 'h1', label: 'Simple Left', html: '<div class="doc-header" ><span contenteditable="false" class="hf-placeholder">[DOCUMENT NAME]</span></div>' },
    { id: 'h2', label: 'Centered Title', html: '<div class="doc-header" style="text-align:center;"><strong><span contenteditable="false" class="hf-placeholder">[DOCUMENT TITLE]</span></strong></div>' },
    { id: 'h3', label: 'Left Logo + Title', html: `<div class="doc-header" style="display:flex;align-items:center;;width:100%"><div  style="width:30%;height:100%;background:#e53935;"></div><div style="flex:1;padding-left:12px;"><span contenteditable="false" class="hf-placeholder">[DOCUMENT NAME]</span></div></div>` },
    { id: 'h4', label: 'Thin Rule + Title', html: '<div class="doc-header" ><div style="border-top:2px solid #ccc;margin-top:6px"></div><div style="margin-top:6px;font-weight:600"><span contenteditable="false" class="hf-placeholder">[DOCUMENT TITLE]</span></div></div>' },
    { id: 'h5', label: 'Two-line Small', html: '<div class="doc-header" ><div style="font-size:12px;color:#777"><span contenteditable="false" class="hf-placeholder">[Company]</span></div><div style="font-weight:600"><span contenteditable="false" class="hf-placeholder">[DOCUMENT NAME]</span></div></div>' },
    { id: 'h6', label: 'Right-Aligned Meta', html: '<div class="doc-header" style="display:flex;justify-content:space-between;align-items:center;"><div><span contenteditable="false" class="hf-placeholder">[DOCUMENT NAME]</span></div><div style="font-size:12px;color:#666">v1.0</div></div>' },
    { id: 'h7', label: 'Banner (colored)', html: '<div class="doc-header" style="background:transparent;color:#333"><strong><span contenteditable="false" class="hf-placeholder">[DOCUMENT NAME]</span></strong></div>' },
    { id: 'h8', label: 'Logo Left / Subtitle', html: '<div class="doc-header" style="display:flex;align-items:center;gap:12px;;border-bottom:1px solid #eee"><div style="width:40px;height:24px;background:#4caf50"></div><div><div style="font-weight:600"><span contenteditable="false" class="hf-placeholder">[DOCUMENT NAME]</span></div><div style="font-size:12px;color:#777"><span contenteditable="false" class="hf-placeholder">[Subtitle or tagline]</span></div></div></div>' },
    { id: 'h9', label: 'Split (left/right)', html: '<div class="doc-header" style="display:flex;justify-content:space-between;align-items:center;"><div><span contenteditable="false" class="hf-placeholder">[Company]</span></div><div style="text-align:right"><span contenteditable="false" class="hf-placeholder">[Document Date]</span></div></div>' },
    { id: 'h10', label: 'Minimal Center Line', html: '<div class="doc-header" style="text-align:center"><div style="border-top:1px solid #ddd;width:60%;margin:0 auto;padding-top:6px"><span contenteditable="false" class="hf-placeholder">[DOCUMENT TITLE]</span></div></div>' }
  ];

  footerTemplates: Array<{ id: string; label: string; html: string }> = [
    { id: 'f1', label: 'Simple Right', html: '<div class="doc-footer" style="text-align:right;border-top:1px dashed #ddd;padding:8px">Page <span contenteditable="false" class="hf-placeholder">[#]</span></div>' },
    { id: 'f2', label: 'Centered Small', html: '<div class="doc-footer" style="text-align:center;border-top:1px dashed #ddd;padding:6px;font-size:12px">Confidential</div>' },
    { id: 'f3', label: 'Left + Right', html: '<div class="doc-footer" style="display:flex;justify-content:space-between;align-items:center;border-top:1px dashed #ddd;padding:8px"><div><span contenteditable="false" class="hf-placeholder">[Company]</span></div><div>Page <span contenteditable="false" class="hf-placeholder">[#]</span></div></div>' },
    { id: 'f4', label: 'Thin Line + Center', html: '<div class="doc-footer" style="padding:6px"><div style="border-top:1px solid #e0e0e0;padding-top:6px;text-align:center"><span contenteditable="false" class="hf-placeholder">[Company]</span> • Confidential</div></div>' },
    { id: 'f5', label: 'Contact Info', html: '<div class="doc-footer" style="padding:8px;border-top:1px solid #eee;font-size:12px;display:flex;justify-content:center;gap:12px"><span contenteditable="false" class="hf-placeholder">[Address • Phone • Email]</span></div>' },
    { id: 'f6', label: 'Left Small', html: '<div class="doc-footer" style="padding:8px;border-top:1px dashed #ddd;text-align:left;font-size:12px"><span contenteditable="false" class="hf-placeholder">© Company 2025</span></div>' },
    { id: 'f7', label: 'Grey Banner', html: '<div class="doc-footer" style="background:#f5f5f5;padding:8px;border-top:1px solid #e0e0e0;text-align:center"><span contenteditable="false" class="hf-placeholder">[Company Name]</span> — Confidential</div>' },
    { id: 'f8', label: 'Page Center / Doc Right', html: '<div class="doc-footer" style="display:flex;justify-content:space-between;align-items:center;padding:8px;border-top:1px solid #eee"><div style="flex:1;text-align:center">Page <span contenteditable="false" class="hf-placeholder">[#]</span></div><div style="flex:1;text-align:right"><span contenteditable="false" class="hf-placeholder">[Document Name]</span></div></div>' },
    { id: 'f9', label: 'Two-row Footer', html: '<div class="doc-footer" style="padding:6px;border-top:1px solid #eee"><div style="font-size:12px"><span contenteditable="false" class="hf-placeholder">[Company Name]</span></div><div style="font-size:11px;color:#777"><span contenteditable="false" class="hf-placeholder">[Address • Contact]</span></div></div>' },
    { id: 'f10', label: 'Left Logo + Right Meta', html: '<div class="doc-footer" style="display:flex;justify-content:space-between;align-items:center;padding:8px;border-top:1px solid #ddd"><div style="display:flex;align-items:center;gap:8px"><div style="width:28px;height:16px;background:transparent"></div><div><span contenteditable="false" class="hf-placeholder">[Company]</span></div></div><div style="font-size:12px;color:#666">Page <span contenteditable="false" class="hf-placeholder">[#]</span></div></div>' }
  ];

  get templates() {
    return this.mode === 'header' ? this.headerTemplates : this.footerTemplates;
  }

  onSelect(templateHtml: string) {
    // Apply selected background/text colors to the HTML before returning/emitting.
    const htmlWithColors = this.applyBg(templateHtml);
    if (this.dialogRef) {
      this.dialogRef.close(htmlWithColors);
      return;
    }
    this.select.emit(htmlWithColors);
  }

  onLogoFile(ev: Event) {
    try {
      const f = (ev.target as HTMLInputElement).files?.[0];
      if (!f) return;
      const reader = new FileReader();
      reader.onload = () => { this.logoSrc = String(reader.result || ''); };
      reader.readAsDataURL(f);
    } catch (e) { console.warn('onLogoFile failed', e); }
  }

  buildLogoTitleHeaderHtml(): string {
    const safeTitle = this.escapeHtml(this.headerTitle || '');
    const safeSubtitle = this.escapeHtml(this.headerSubtitle || '');
    const tempId = 'logo-' + Date.now().toString(36);
    const alignment = 'left';
    const logoHtml = this.logoSrc
      ? `<div class="image-block align-${alignment} use-flow" contenteditable="false" ` +
        `data-image-id="${tempId}" data-image-align="${alignment}" data-image-region="header" ` +
        `data-image-w="0" data-image-h="0" data-crop-enabled="0" data-crop-x="0" data-crop-y="0" data-crop-w="1" data-crop-h="1">` +
        `<div class="image-frame" style="display:inline-block;max-width:100%;height:auto;position:relative;">` +
        `<img class="image-content" data-upload-temp-id="${tempId}" src="${this.logoSrc}" draggable="false" style="display:block;max-width:100%;height:auto;object-fit:contain" />` +
        `</div>` +
        `</div>`
      : `<div style="width:${this.logoWidth};min-width:40px"></div>`;

    const titleHtml = `<div style="flex:1;padding-left:12px;">
      <div style="font-weight:700;font-size:18px;">${safeTitle}</div>
      <div style="font-size:12px;color:#333">${safeSubtitle}</div>
    </div>`;

    const baseStyle = `display:flex;align-items:center;padding:8px;width:100%;`;
    const bgStyle = this.headerBg ? `background:${this.headerBg};color:${this.headerColor};` : '';
    return `<div class="doc-header" style="${bgStyle}${baseStyle}">${logoHtml}${titleHtml}</div>`;
  }

  applyBg(html: string) {
    const bg = this.mode === 'header' ? this.headerBg : this.footerBg;
    const color = this.mode === 'header' ? this.headerColor : this.footerColor;
    let out = html;
    // apply bg/text to header/footer container
    out = out.replace(/<div class=\"(doc-header|doc-footer)\"([^>]*)>/g, (m: string, cls: string, attrs: string) => {
      const styleMatch = attrs.match(/style=\"([^\"]*)\"/);
      if (styleMatch) {
        const newStyle = styleMatch[1] + `;background:${bg};color:${color};`;
        return `<div class=\"${cls}\"${attrs.replace(/style=\"[^\"]*\"/, `style=\"${newStyle}\"`)}>`;
      } else {
        return `<div class=\"${cls}\"${attrs} style=\"background:${bg};color:${color};\">`;
      }
    });

    // apply horizontal line settings: remove existing rule markers and insert our rule
    if (this.lineEnabled) {
      // remove any existing border-top/border-bottom placeholder divs and <hr>
      out = out.replace(/<div[^>]*style=\"[^\"]*(border-(top|bottom)\:[^\"]*)[^\"]*\"[^>]*>\s*<\/div>/gi, '');
      out = out.replace(/<hr[^>]*>/gi, '');

      // Insert the rule inside the doc header/footer wrapper at top or bottom
      out = out.replace(/(<div[^>]*class=\"(doc-header|doc-footer)\"[^>]*>)([\s\S]*?)(<\/div>)/gi, (m: string, open: string, cls: string, inner: string, close: string) => {
        const ruleHtml = `<div style=\"height:${this.lineThickness}px;background:${this.lineColor};width:100%;border:none;\"></div>`;
        if (this.linePosition === 'bottom') {
          return `${open}${inner}${ruleHtml}${close}`;
        } else {
          return `${open}${ruleHtml}${inner}${close}`;
        }
      });
    }

    return out;
  }


  private escapeHtml(s: string) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
